import { cn } from "@/lib/utils";

export interface WifibotLogoProps {
  /** Rendered wordmark font-size in px. */
  height?: number;
  className?: string;
}

/**
 * WiFiBot brand mark: a monospace terminal lockup — an amber prompt caret,
 * the "WiFiBot" wordmark with "Bot" in the signal amber, and a blinking
 * underscore cursor. Colours come from wifibot.css (the panel is always dark).
 * Always "WiFiBot" (capital F, capital B).
 */
export function WifibotLogo({ height = 28, className }: WifibotLogoProps) {
  return (
    <span
      role="img"
      aria-label="WiFiBot"
      className={cn("wb-logo", className)}
      style={{ fontSize: height }}
    >
      <svg
        className="wb-logo__caret"
        width="0.62em"
        height="0.62em"
        viewBox="0 0 12 12"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M3.5 2.5 L8 6 L3.5 9.5"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="wb-logo__word">
        WiFi<span className="wb-logo__accent">Bot</span>
      </span>
      <span className="wb-logo__cursor" aria-hidden="true" />
    </span>
  );
}
